// src/modules/config/components/panels/BulkActions.tsx

import React from 'react';
import { Button, Divider, Tooltip } from 'antd'; // Импортируем Tooltip
import { QrcodeOutlined, DownloadOutlined } from '@ant-design/icons'; // Импортируем DownloadOutlined

interface BulkActionsProps {
  selectedRowKeys: React.Key[];
  loading: boolean;
  onBulkGenerateQR: () => void;
  onBulkDownloadQR: () => void; // !!! НОВЫЙ ПРОПС
  onClearSelection: () => void;
}

export const BulkActions: React.FC<BulkActionsProps> = ({
  selectedRowKeys,
  loading,
  onBulkGenerateQR,
  onBulkDownloadQR, // Используем
  onClearSelection
}) => {
  if (selectedRowKeys.length === 0) return null;

  return (
    <>
      <Tooltip title="Сгенерировать QR-коды для выбранных блюд, если они не созданы">
        <Button
          icon={<QrcodeOutlined />}
          onClick={onBulkGenerateQR}
          loading={loading}
          size="small"
        >
          Создать QR ({selectedRowKeys.length})
        </Button>
      </Tooltip>
      
      <Tooltip title={`Скачать ZIP-архив с QR-кодами для выбранных блюд`}>
        <Button
          icon={<DownloadOutlined />} // Иконка скачивания
          onClick={onBulkDownloadQR} // Обработчик скачивания
          loading={loading}
          size="small"
          disabled={loading} 
        >
          Скачать QR ({selectedRowKeys.length})
        </Button>
      </Tooltip>

      <Button
        onClick={onClearSelection}
        size="small"
      >
        Отменить выбор
      </Button>
      <Divider type="vertical" />
    </>
  );
};